import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { PersonalModel } from '../../models/Personal/personalModel';
import { IndividualContract } from '../../models/IndividualContract/individualContract';
import { IndividualContractId } from '../../models/IndividualContract/individualContractId';
import { DocumentI, DocumentIndividualPost, getDocumentIndividualContract } from '../../models/IndividualContract/document';
import {Back, FirePersonal, GetPersonalBlackList, PersonalBlackList, PersonalBlackListHistorical} from '../../interfaces/interfaces';
import {BlacklistResponse} from '../../components/cards-modules/cards-personal/models/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ContratingService {

    constructor(
        private api: ApiService,
        private _http: HttpClient
    ) { }

    getIndividualContracts(): Observable<IndividualContractId[]> {
        return this._http.get<IndividualContractId[]>(this.api.getUrl(`api/IndividualContract`));
    }

     // GET personalDocuemnt ID
    getPersonalDocument(typeDocument: string, document: string){
        return this._http.get(this.api.getUrl(`api/Personal/ByDocument?documentType=${typeDocument}&documentNumber=${document}`));
    }

    getManagedEmployers() {
        return this._http.get(this.api.getUrl(`api/Company/ManagedEmployers`));
    }

    postPersonal(personal): Observable<PersonalModel> {
        return this._http.post<PersonalModel>(this.api.getUrl(`api/Personal`), personal);
    }

    postPersonalEmployerInfo(PersonalEmployerInfo) {
        return this._http.post(this.api.getUrl(`api/PersonalEmployerInfo`), PersonalEmployerInfo);
    }

    putPersonalEmployerInfo(Id, PersonalEmployerInfo) {
        return this._http.put(this.api.getUrl(`api/PersonalEmployerInfo/${Id}`), PersonalEmployerInfo);
    }

    // update photo Personal
    updatePhotoPersonal(id, file) {
        return this._http.put(this.api.getUrl('api/PersonalEmployerInfo/UpdatePhoto/' + id), file);
    }

    postIndividualContract(individualContract): Observable<IndividualContract> {
        return this._http.post<IndividualContract>(this.api.getUrl(`api/IndividualContract`), individualContract);
    }

    deleteIndividualContract(individualContractId) {
        return this._http.delete(this.api.getUrl(`api/IndividualContract/${individualContractId}`));
    }

    getIndividualContractId(Id): Observable<IndividualContractId> {
        return this._http.get<IndividualContractId>(this.api.getUrl(`api/IndividualContract/${Id}`));
    }

    getPersonalId(Id): Observable<PersonalModel> {
        return this._http.get<PersonalModel>(this.api.getUrl(`api/Person/${Id}`));
    }

    getDocument(): Observable<DocumentI[]> {
        return this._http.get<DocumentI[]>(this.api.getUrl(`api/Document`));
    }

    getProyectSelect() {
        return this._http.get(this.api.getUrl(`api/Project/Select`));
    }

    getContributorType() {
        return this._http.get(this.api.getUrl(`api/SocialSecurityDocument/ContributorType`));
    }

    getDocuemntsIndividualContract(IdIndividualContract): Observable<getDocumentIndividualContract[]> {
        return this._http.get<getDocumentIndividualContract[]>(this.api.getUrl(`api/Document/IndividualContract/${IdIndividualContract}`));
    }

    postDocumentDataIndividual(documents: DocumentIndividualPost) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract`), documents);
    }

    putDocumentFileIndividual(Id, FileData) {
        return this._http.put(this.api.getUrl(`api/Document/IndividualContract/Upload/` + Id), FileData);
    }

    putIndividualContract(Id, individualContract) {
        return this._http.put(this.api.getUrl(`api/IndividualContract/` + Id), individualContract);
    }

    getPersonalEmployerInfoExit(EmployerId, PersonalId){
        return this._http.get(this.api.getUrl(
          `api/PersonalEmployerInfo/EmployerPersonal?personalId=${PersonalId}&employerId=${EmployerId}`));
    }

    // Apis Generate Solicitud
    postGenerateDocumentDatosContrato(Id) {
        return this._http.post(this.api.getUrl(`api/Document/Individualcontract/RequestHiringDocument/` + Id), Id);
    }

    postGenerateDocumentDatosContratoAproved(Id) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract/RequestAprovedHiringDocument/` + Id), Id);
    }

    postGenerateDocumentIndividualContractRechazada(Id) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract/RejectHiringRequestDocument/` + Id), Id);
    }
    // Apis Generate Solicitud Fin

    // Documentos generate Contrato
    postGenerateProjectContract(Id) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract/GenerateProjectContract/` + Id), Id);
    }

    postGenerateDocumentMedicalAdviceAcknowledgement(Id) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract/MedicalAdviceAcknowledgement/` + Id), Id);
    }

    postGenerateDocumentDataAuthorization(Id) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract/DataAuthorization/` + Id), Id);
    }

    postGenerateDocumentAuthMedicalExam(Id) {
        return this._http.post(this.api.getUrl(`api/Document/IndividualContract/AuthMedicalExam/` + Id), Id);
    }

    // Documentos generate Contrato FIN

    getTownIdCity(CodeCity) {
        return this._http.get(this.api.getUrl(`api/Town/City/${CodeCity}`));
    }

    postGenerateDocumentExamenMedico(Id, examType) {
        return this._http.post(this.api.getUrl(
          `api/Document/IndividualContract/GenerateMedicalExamRequest/${Id}?examType=${examType}`), Id + examType);
    }

    getBanks(): Observable<Back[]>{
        return this._http.get<Back[]>(this.api.getUrl(`api/Bank`));
    }

    changeStateIndividualContract(model){
        return this._http.post(this.api.getUrl(`api/IndividualContract/AddStage`), model);
    }

    getPersonalBlackList(DocumentType, DocumentNumber, CompanyInfoId): Observable<boolean>{
        return this._http.get<boolean>(this.api.getUrl(`api/PersonalBlackList/ByDoc?DocumentType=${DocumentType}&DocumentNumber=${DocumentNumber}${CompanyInfoId === '' ? '' : '&adminInfoId=' + CompanyInfoId}`));
    }

    getPersonalBlackListByType(documentType: string, documentNumber: string, adminInfoId: string, type: string
    ): Observable<BlacklistResponse> {
      let params = new HttpParams().set('DocumentType', documentType).set('DocumentNumber', documentNumber).set('type', type);

      if (adminInfoId) {
        params = params.set('adminInfoId', adminInfoId);
      }
      return this._http.get<BlacklistResponse>(this.api.getUrl('api/PersonalBlackList/by-type/by-doc'), { params });
    }

    getPersonalBlackListInfoSanction(DocumentType, DocumentNumber, CompanyInfoId): Observable<BlacklistResponse>{
        return this._http.get<BlacklistResponse>(this.api.getUrl(`api/PersonalBlackList/sanction/by-doc?DocumentType=${DocumentType}&DocumentNumber=${DocumentNumber}${CompanyInfoId === '' ? '' : '&adminInfoId=' + CompanyInfoId}`));
    }

    getPersonalBlackListInfoVetos(DocumentType, DocumentNumber, CompanyInfoId): Observable<BlacklistResponse>{
      return this._http.get<BlacklistResponse>(this.api.getUrl(`api/PersonalBlackList/veto/by-doc?DocumentType=${DocumentType}&DocumentNumber=${DocumentNumber}${CompanyInfoId === '' ? '' : '&adminInfoId=' + CompanyInfoId}`));
    }

    getIndividualContractPersonalInforId(personalemployerinfoid) {
        return this._http.get(this.api.getUrl(`api/IndividualContract/GetByPersonalEnployerInfo/${personalemployerinfoid}`));
    }

    getIndividualContractPersonal(DocumentType, DocumentNumber): Observable<any[]>{
        return this._http.get<any[]>(this.api.getUrl(`api/IndividualContract/ByDocument?documentType=${DocumentType}&documentNumber=${DocumentNumber}`));
    }

    postPersonalBlackListSanction(personalBlack: PersonalBlackList) {
        return this._http.post(this.api.getUrl(`api/PersonalBlackList/sanction`), personalBlack);
    }

    postPersonalBlackListVeto(personalBlack: PersonalBlackList) {
      return this._http.post(this.api.getUrl(`api/PersonalBlackList/veto`), personalBlack);
    }

    putPersonalBlackListFile(id: string, file) {
      return this._http.put(this.api.getUrl(`api/PersonalBlackList/UpdateFile/${id}`), file);
    }

    putPersonalBlackList(id: string, personalBlack: PersonalBlackList) {
        return this._http.put(this.api.getUrl(`api/PersonalBlackList/${id}`), personalBlack);
    }

    getHistoricalBlackList(DocumentType, DocumentNumber): Observable<PersonalBlackListHistorical[]> {
        return this._http.get<PersonalBlackListHistorical[]>(this.api.getUrl(`api/PersonalBlackList/History?DocumentType=${DocumentType}&DocumentNumber=${DocumentNumber}`));
    }

  /**
   * Permite desvincular el personal de todos los contratos
   */

  postFirePersonal(firePersonal: FirePersonal) {
        return this._http.put(this.api.getUrl(`api/Contract/FirePersonal`), firePersonal);
    }

    getAllPersonalBlackList(): Observable<GetPersonalBlackList[]> {
        return this._http.get<GetPersonalBlackList[]>(this.api.getUrl('api/PersonalBlackList'));
    }

    deletePersonalBlackList(personalBlackListId) {
        return this._http.delete(this.api.getUrl(`api/PersonalBlackList/${personalBlackListId}`));
    }

    getListSelectContracting(CompanyId) {
        return this._http.get(this.api.getUrl(`api/contract/selectcontracting/${CompanyId}`));
    }

    deleteDocumentId(Id) {
        return this._http.delete(this.api.getUrl(`api/Document/IndividualContract/${Id}`));
    }

    deleteOrdenData(IdIndividualContract) {
        return this._http.patch(this.api.getUrl(
          `api/IndividualContract/resetIndividualContract/${IdIndividualContract}`), IdIndividualContract);
    }

    // Blacklist Personal
    getBlacklistPersonalPolicy(personalCompanyInfoId: string) {
      return this._http.get(this.api.getUrl(`api/PersonalBlackList/Policy/${personalCompanyInfoId}`));
    }

    postBlacklistPersonalPolicy(model) {
      return this._http.post(this.api.getUrl(`api/PersonalBlackList/Policy`), model);
    }

}
